// Content Platform — service content resolver (Phase 1). Fail-closed: prefers an authored module,
// otherwise the factual default. ALWAYS returns a valid block list for a catalogue slug, so a service
// page can never become thin/broken (anti-thin invariant). Pure, node-importable.

import { AUTHORED_SERVICE_CONTENT } from './index.js';
import { defaultServiceBlocks } from './defaultServiceContent.js';

/**
 * Resolve the block list for a service slug.
 * @param {string} slug
 * @returns {Array} ordered blocks
 */
export function getServiceContent(slug) {
  const authored = AUTHORED_SERVICE_CONTENT[slug];
  if (authored && Array.isArray(authored.blocks) && authored.blocks.length) return authored.blocks;
  return defaultServiceBlocks(slug);
}
